export default {
  // Hero
  hero_title: "KATALOG FÜR VERTIKALBAUGERÄTE",
  hero_view_products: "Produkte Ansehen",
  hero_request_quote: "Angebot Anfordern",

  // Products Section
  products_title: "Hochleistungsgeräte",
  product1_name: "Zahnstangen-Bauaufzug",
  product2_name: "Kletterkran mit Hebesystem",

  // Specifications
  spec_work_height: "Arbeitshöhe",
  spec_load_capacity: "Tragfähigkeit",
  spec_speed: "Geschwindigkeit",
  spec_configuration: "Konfiguration",
  spec_total_area: "Gesamte Innenfläche",
  spec_floor_area: "Bodenfläche",
  spec_volume: "Ungefähres Volumen",
  spec_tower_height: "Turmhöhe",
  spec_service_height: "Servicehöhe",
  spec_max_capacity: "Maximale Kapazität",
  spec_steel_cables: "Stahlseile",

  // Product Details
  product1_safety_title: "Sicherheitsmerkmale",
  product1_safety_desc: "System ohne Tor",
  product2_accessories_title: "Enthaltenes Zubehör",
  product2_accessories_desc: "Gabel für Lasten bis 2.000 kg + Betoneimer",

  // Video Section
  video_title: "Sehen Sie die Geräte in Betrieb",

  // Conditions
  conditions_delivery_title: 'Liefer- und Zahlungsbedingungen',
  conditions_delivery_subtitle: 'Informationen zu Fristen und Logistik',
  conditions_shipping_title: 'Versandprognose',
  conditions_shipping_desc: '30 Tage nach Auftragsbestätigung',
  conditions_delivery_card_title: 'Lieferung',
  conditions_delivery_desc: '60 Tage nach Versand (Zielhafen)',
  conditions_packaging_title: 'Verpackung',
  conditions_packaging_desc: 'Holzkiste',
  conditions_warranty_title: 'Garantie',
  conditions_warranty_period: '1 Jahr vom Hersteller',
  conditions_manufacturer_title: 'Hersteller',

  // Contact
  contact_title: "Kontaktieren Sie Uns",
  contact_schedule_title: "Termin Vereinbaren",
  contact_schedule_desc: "Sprechen Sie mit unserem Team über Microsoft Teams",
  contact_email_title: "Kontaktieren Sie Uns",
  contact_email_desc: "Senden Sie eine E-Mail an unser Vertriebsteam",

  // Footer
  footer_description: "Importierte Geräte für Vertikalbau",
  footer_products: "Produkte",
  footer_product1: "Bauaufzug",
  footer_product2: "Kletterkran",
  footer_info: "Informationen",
  footer_about: "Über Uns",
  footer_warranty: "Garantie",
  footer_delivery: "Lieferung",
  footer_contact: "Kontakt",
  footer_address: "R. Voluntários da Pátria, nº 2468 / 2490, 6. Stock",
  footer_building: "Brasília Corporate Gebäude",
  footer_hours: "Montag bis Freitag, 08:30 bis 18:00 Uhr (GMT -03:00)",
  footer_rights: "© 2026 Moviis. Alle Rechte vorbehalten.",

  // Language Switcher
  language_select: "Sprache wählen",

  share: {
    whatsappMessage: 'Hallo! Hier ist der Moviis-Katalog für vertikale Bauausrüstung:',
    emailSubject: 'Moviis-Katalog — Vertikale Bauausrüstung',
    emailBody: 'Hallo! Hier ist der Moviis-Katalog für vertikale Bauausrüstung:',
    whatsappTooltip: 'Auf WhatsApp teilen',
    emailTooltip: 'Per E-Mail teilen',
  },

  // Financial Summary
  financial_title: 'Finanzübersicht',
  financial_subtitle: 'Werte und Zahlungsbedingungen',
  financial_total_label: 'Bestellsumme',
  financial_total_value: 'Auf Anfrage',
  financial_installment1_label: 'Rate 1',
  financial_installment1_desc: '30% zum Produktionsstart',
  financial_installment1_value: 'Auf Anfrage',
  financial_installment2_label: 'Rate 2',
  financial_installment2_desc: 'Produktzahlung für Versandfreigabe',
  financial_installment2_value: 'Auf Anfrage',
  financial_installment3_label: 'Rate 3 (Saldo)',
  financial_installment3_desc: 'Ankunft am Zielort (Hafen oder Flughafen)',
  financial_installment3_value: 'Auf Anfrage',
  
  // Considerations
  financial_considerations_title: 'Angebotsüberlegungen',
  financial_considerations_subtitle: 'Wichtige Geschäftsbedingungen',
  financial_validity_label: 'Angebotsgültigkeit:',
  financial_validity: '15 Tage',
  financial_shipping_label: 'Versandfrist:',
  financial_shipping: 'Geräte müssen innerhalb von 3 Monaten versandt werden. Nach diesem Zeitraum gilt der Vertrag als ungültig.',
  financial_observation_label: 'Hinweis:',
  financial_observation: 'Da es sich um einen Direktimport von 10 Geräten handelt, führt jeder Austausch oder jede Aufnahme neuer Artikel zu einer Neuberechnung der Werte.',
  financial_assembly_label: 'Montage und technische Wartung:',
  financial_assembly: 'Nicht enthalten (Verantwortung des Käufers).',
  
  // Action Buttons
  financial_btn_print: 'Drucken',
  financial_btn_pdf: 'PDF herunterladen',
  financial_btn_whatsapp: 'Per WhatsApp senden',
  financial_btn_email: 'Per E-Mail senden',
};